import { Route } from '@angular/router';

export const assetTransferRoutes: Route[] = [
  {
    path: 'asset-transfer/post-requests',
    loadComponent: () =>
      import('./post-requests/post-requests.component').then(
        (m) => m.PostRequestsComponent
      ),
  },
];
